import { readLanguageSnapshot } from '../../state/languageState';
export const MAINTENANCE_MESSAGE_EVENT_NAME = 'npc:maintenance-message:update';
export const MAINTENANCE_MESSAGE_CLEAR_EVENT_NAME = 'npc:maintenance-message:clear';
export const MAINTENANCE_MESSAGE_STORAGE_KEY = 'npc:maintenance-message:active';
export const MAINTENANCE_MESSAGE_SOCKET_EVENT = 'operations:maintenance-messages';

function safeString(value, fallback = '') {
  if (value == null) return fallback;
  return String(value).trim();
}

function normalizeItem(value = {}, serverOffsetMs = 0) {
  const startsAt = safeString(value.startsAt ?? value.starts_at);
  const endsAt = safeString(value.endsAt ?? value.ends_at);
  return {
    ...value,
    id: safeString(value.id ?? value.messageSetId ?? value.message_set_id),
    messageSetId: safeString(value.messageSetId ?? value.message_set_id ?? value.id),
    message: safeString(value.message ?? value.text),
    language: safeString(value.language).toLowerCase(),
    startsAt,
    starts_at: startsAt,
    endsAt,
    ends_at: endsAt,
    priority: Number(value.priority || 0),
    version: Number(value.version || 0),
    serverOffsetMs: Number.isFinite(Number(value.serverOffsetMs))
      ? Number(value.serverOffsetMs)
      : Number(serverOffsetMs || 0),
    receivedAt: new Date().toISOString(),
  };
}

export function maintenanceMessageNow(message, clientNow = Date.now()) {
  return Number(clientNow) + Number(message?.serverOffsetMs || 0);
}

export function isMaintenanceMessageActive(message, at = null) {
  if (!message || !message.message) return false;
  const startsAt = Date.parse(message.startsAt || message.starts_at || '');
  const endsAt = Date.parse(message.endsAt || message.ends_at || '');
  if (!Number.isFinite(startsAt) || !Number.isFinite(endsAt)) return false;
  const checkAt = at == null ? maintenanceMessageNow(message) : Number(at);
  return startsAt <= checkAt && checkAt < endsAt;
}

export function saveMaintenanceMessageSnapshot(message) {
  if (typeof window === 'undefined') return;
  try {
    if (!message || !isMaintenanceMessageActive(message)) {
      window.sessionStorage.removeItem(MAINTENANCE_MESSAGE_STORAGE_KEY);
      return;
    }
    window.sessionStorage.setItem(MAINTENANCE_MESSAGE_STORAGE_KEY, JSON.stringify(message));
  } catch (_) {}
}

export function readMaintenanceMessageSnapshot() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.sessionStorage.getItem(MAINTENANCE_MESSAGE_STORAGE_KEY);
    if (!raw) return null;
    const message = normalizeItem(JSON.parse(raw));
    const currentLanguage = readLanguageSnapshot().current || 'en';
    const languageMatches = !message.language
      || message.language === currentLanguage
      || (currentLanguage !== 'en' && message.language === 'en');
    if (!isMaintenanceMessageActive(message) || !languageMatches) {
      window.sessionStorage.removeItem(MAINTENANCE_MESSAGE_STORAGE_KEY);
      return null;
    }
    return message;
  } catch (_) {
    try { window.sessionStorage.removeItem(MAINTENANCE_MESSAGE_STORAGE_KEY); } catch (__) {}
    return null;
  }
}

export function dispatchMaintenanceMessages(payload = {}, source = 'socket') {
  if (typeof window === 'undefined') return null;
  const rawItems = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.items)
      ? payload.items
      : [];
  const serverTimeMs = Date.parse(payload?.serverTime || payload?.server_time || '');
  const serverOffsetMs = Number.isFinite(serverTimeMs) ? serverTimeMs - Date.now() : 0;
  const activeItems = rawItems
    .map((item) => normalizeItem(item, serverOffsetMs))
    .filter((item) => isMaintenanceMessageActive(item))
    .sort((a, b) => Number(b.priority || 0) - Number(a.priority || 0));
  const currentLanguage = readLanguageSnapshot().current || 'en';
  const selectedItem = activeItems.find((item) => item.language === currentLanguage)
    || (currentLanguage !== 'en' ? activeItems.find((item) => item.language === 'en') : null)
    || activeItems.find((item) => !item.language)
    || null;
  const selected = selectedItem ? { ...selectedItem, source } : null;
  saveMaintenanceMessageSnapshot(selected);
  try {
    window.dispatchEvent(new CustomEvent(selected ? MAINTENANCE_MESSAGE_EVENT_NAME : MAINTENANCE_MESSAGE_CLEAR_EVENT_NAME, {
      detail: selected,
    }));
  } catch (_) {}
  return selected;
}
